import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-consulta-pendencias-financeiras',
  templateUrl: './consulta-pendencias-financeiras.component.html',
  styleUrls: ['./consulta-pendencias-financeiras.component.scss']
})
export class ConsultaPendenciasFinanceirasComponent implements OnInit {
  title = "PENDÊNCIAS FINANCEIRAS";

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'success';
  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
    this.verificaRegistros();
  }

  verificaRegistros() {
    if(this.consulta.registros.length > 0) {
      this.status = "danger";
    }else {
      this.codigoControle = "SEMREGISTRO_OK";
    }
  }

}
